import React, { useState, useRef, useEffect, useMemo } from "react";
import { format, parseISO } from 'date-fns'; // Import the format and parseISO functions
import { enUS } from 'date-fns/locale'; // Import the English locale if needed
 import { getResearchPData, addResearchPublications, editResearchPData, deleteResearchPData } from "../../controllers/researchPublications.controller"
 import toast from 'react-hot-toast';
 import {
     IconPlus,
 } from "@tabler/icons-react";
 import { RiListRadio, RiDeleteBin2Line } from "react-icons/ri";
 import { FiEdit } from "react-icons/fi";
 import Button from "../../Components/Button";
 import Page from "../../Components/Page";
 const ResearchPublications = () => {
 
     const [data, setData] = useState([]);
     const [selectedRowId, setSelectedRowId] = useState(null);
 
     const [formData, setFormData] = useState({
         title: "",
         abstract: "",
         //file: null,
         file: data.image || null,
         authors: "",
         publication_date:null,
         journal_name:""

     });
 
 
     const handleChange = (e) => {
         const { name, value } = e.target;
         setFormData({ ...formData, [name]: value });
     };
 
     const handleFileChange = (e) => {
         setFormData({ ...formData, file: e.target.files[0] });
     };
 
     const handleSubmit = (e) => {
         e.preventDefault();
         console.log("Form Submitted: ", formData);
         // Add form submission logic here
     };
 
 
     // get
     const fetchTableData = async () => {
         const res = await getResearchPData({})
         console.log('res => ', res)
 
         if (res.status === 200) {
             const apiData = res?.data?.data;
             const tableData = apiData?.map((d) => ({
                 id: d.id,
                 title: d.title,
                 authors: d.authors,
                 abstract: d.abstract,
                 file: d.files,
                 image: d.image_url || "",
                 publication_date: d.publication_date,
                 journal_name: d.journal_name
             }))
             setData(tableData)
         }
     }
 
     useEffect(() => {
         fetchTableData()
     }, [])
 
 
 
 
     const addNewPublication = async () => {
         try {
             const { title, abstract, file, authors,journal_name,publication_date } = formData;
 
             if (!title || !abstract || !file || !authors || !journal_name || !publication_date) {
                 toast.error("Please fill in all the required fields and upload a document.");
                 return;
             }
 
             toast.loading("Submitting your data...");
 
 
             const res = await addResearchPublications({
                 title,
                 abstract,
                 file,
                 authors,
                 journal_name,
                 publication_date
             });
 
             const message = res.data.message;
             toast.dismiss();
 
             if (res.status === 200) {
                 toast.success(message);
                 setFormData({
 
                     title: "",
                     abstract: "",
                     file: null,
                     authors: "",
                     journal_name:"",
                     publication_date:null
                 });
                 //setSelectedYear(new Date().getFullYear());
                 fetchTableData()
             } else {
                 toast.error(message || "Failed to add research data.");
             }
         } catch (error) {
             toast.dismiss();
             console.error("Error adding research data:", error);
 
 
             const message = error?.response?.data?.message || "Something went wrong!";
             toast.error(message);
         }
     };
 
 
 
 
     const editPublicationBtn = async () => {
         try {
             const { title, abstract, file, authors,journal_name,publication_date } = formData;
 
             if (!title || !abstract || !file || !authors|| !journal_name || !publication_date) {
                 toast.error("Please fill in all the required fields and upload a document.");
                 return;
             }
 
             toast.loading("Submitting your data...");
 
 
             const res = await editResearchPData({
                 id: selectedRowId,
                 title,
                 abstract,
                 file,
                 authors,
                 journal_name,
                 publication_date
             });
 
             const message = res.data.message;
             toast.dismiss();
 
             if (res.status === 200) {
                 toast.success(message);
                 setFormData({
 
                     title: "",
                     abstract: "",
                     file: null,
                     authors: "",
                     journal_name:"",
                     publication_date:null
                 });
 
                 document.getElementById("modal-edit").close()
                 fetchTableData()
             } else {
                document.getElementById("modal-edit").close()
                 toast.error(message || "Failed to add research publication data.");
             }
         } catch (error) {
             toast.dismiss();
             console.error("Error adding research data:", error);
 
 
             const message = error?.response?.data?.message || "Something went wrong!";
             toast.error(message);
         }
     };
     //     try {
     //         const { title, abstract, file, authors } = formData;
 
 
     //         if (!title || !abstract || !file || !authors) {
     //             toast.error("Please fill in all the required fields and upload a document.");
 
 
     //             return;
     //         }
 
 
     //         toast.loading("Submitting your data...");
 
 
     //         const response = await editResearchPData({
     //             id: selectedRowId,
     //             title,
     //             abstract,
     //             file,
     //             authors,
     //         });
 
     //         const { message } = response.data;
     //         toast.dismiss(); 
 
     //         if (response.status === 200) {
 
     //             toast.success(message);
 
 
     //             setFormData({
     //                 title: "",
     //                 abstract: "",
     //                 file: null,
     //                 authors: "",
     //             });
     //             document.getElementById("modal-edit").close();
     //             setSelectedRowId(null);
 
 
     //             fetchTableData();
     //         } else {
 
     //             toast.error(message || "Failed to update research publication data.");
     //         }
     //     } catch (error) {
     //         toast.dismiss(); 
     //         console.error("Error updating research data:", error);
 
 
     //         const message = error?.response?.data?.message || "Something went wrong!";
     //         toast.error(message);
     //     }
     // };
 
 
     const deleteResearchPBtn = async () => {
        try {
            if (selectedRowId) {
                toast.loading("Please wait...");
                const res = await deleteResearchPData({ id: selectedRowId })
                const message = res.data.message;

                toast.dismiss();
                if (res.status === 200) {
                    toast.success(message);
                    fetchTableData()
                    setSelectedRowId(null)
                    document.getElementById("modal-delete").close()
                } else {
                    toast.error(message);
                }
            }
        } catch (error) {
            console.error(error);
            const message = error?.response?.data?.error || "Something went wrong!";
            toast.dismiss();
            toast.error(message);
        }
    }

    const [toggles, setToggles] = useState([
        { label: 'Add New', icon: <IconPlus />, isToggled: false },
        { label: 'List', icon: <RiListRadio />, isToggled: true },
    ]);

    const handleToggle = (index) => {
        setToggles((prevToggles) =>
            prevToggles.map((toggle, i) => ({ ...toggle, isToggled: i === index }))
        );
    };

    const toggeledIndex = useMemo(() => {
        return toggles.findIndex((d) => d.isToggled)
    }, [toggles])

     // Helper function to format the date
     const formatDate = (dateString) => {
         if (!dateString) return "";
         try {
             const date = parseISO(dateString); // Parse the ISO string
             return format(date, "MM-dd-yyyy", { locale: enUS }); // Format as MM-DD-YYYY
         } catch (error) {
             console.error("Error formatting date:", error);
             return "";
         }
     };
     const formatISODateForInput = (dateString) => {
        if (!dateString) return '';
        try {
          const date = parseISO(dateString);
          return format(date, 'yyyy-MM-dd'); // Format required by input type="date"
        } catch (error) {
          console.error("Error formatting date:", error);
          return '';
        }
      };
    

    return (
        <Page className="px-8 py-6">
            <div className='flex items-center gap-10 text-xl'>
                <div className="text-[#100f13]">
                    Research & Student Life / Research /  <span className="text-[black] bg-white mt-6">Research Publications</span>
                </div>
            </div>
            <div className="flex flex-wrap gap-4 mt-4">
                {toggles.map((toggle, index) => (
                    <div key={toggle.id} className="flex flex-col items-center">

                        <Button styles={'h-100'} outlined={!toggle.isToggled} onClick={() => handleToggle(index)}>
                            <span className="flex flex-row items-center justify-center w-[150px]">{toggle.icon} {toggle.label}</span>
                        </Button>

                    </div>

                ))}
            </div>

            <div className="w-full p-6 mx-auto mt-10 bg-white rounded-lg shadow-lg">
                {toggeledIndex === 1 ? (
                    <div>
                        <h1 className="text-xl font-bold mb-2 text-[#4B465C] mt-6">Publication List</h1>
                        {/* <p className="mb-4 text-gray-600">A total of 5 data you can collect!</p> */}

                        <table className="w-full bg-white border-collapse rounded-lg shadow-md">
                            <thead>
                                <tr className="bg-gray-100 text-[#4B465C]">
                                    <th className="w-1/4 px-4 py-2 text-center">Title</th>
                                    <th className="w-1/4 px-4 py-2 text-center"> Authors</th>

                                    <th className="w-1/4 px-4 py-2 text-center">Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {data.map((item, index) => (
                                    <tr key={item.id} className="border-b hover:bg-gray-50">
                                        <td className="px-4 py-2 text-center">{item.title}</td>

                                        <td className="px-4 py-2 text-center">{item.authors}</td>

                                        <td className="px-4 py-2 text-center">
                                            <div className="flex justify-center gap-4">
                                                <button
                                                    onClick={() => {
                                                        setSelectedRowId(item.id)
                                                        document.getElementById("modal-delete").showModal();
                                                    }}
                                                    className="flex items-center px-3 py-1 bg-[#A8AAAE14] text-[#A8AAAE] border border-[#A8AAAE] rounded-md hover:bg-gray-300"
                                                >
                                                    Delete
                                                    <RiDeleteBin2Line className="ml-2" />
                                                </button>

                                                <button onClick={() => {
                                                    console.log('item data => ', item)
                                                    setSelectedRowId(item.id)
                                                    setFormData((prevState) => ({
                                                        ...prevState,                                                        
                                                        title: item.title,
                                                        abstract: item.abstract,                                                        
                                                        authors: item.authors,
                                                        file: item.file,
                                                        journal_name:item.journal_name,
                                                        publication_date:formatISODateForInput(item.publication_date)

                                                    }))
                                                    document.getElementById("modal-edit").showModal();
                                                }} className="px-3 py-1 bg-[#92288C14] text-[#92288C] border border-[#92288C] rounded-md flex items-center gap-1">
                                                    Edit
                                                    <FiEdit />
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                ) : (
                    <div>
                        <h1 className="mb-6 text-2xl font-bold">Add Publication</h1>
                        <form onSubmit={(e) => e.preventDefault()}>

                            <div className="mb-4">
                                <label htmlFor="title" className="block mb-2 text-gray-600">
                                    Title
                                </label>
                                <input
                                    type="text"
                                    id="title"
                                    name="title"
                                    value={formData.title}
                                    onChange={handleChange}
                                    className="block w-full px-3 py-2 border border-gray-300 rounded-lg shadow-sm"
                                />
                            </div>
                            <div className="mb-4">
                                <label htmlFor="abstract" className="block text-sm font-medium text-gray-700">
                                    Abstract
                                </label>
                                <textarea
                                    id="abstract"
                                    name="abstract"
                                    value={formData.abstract}
                                    onChange={handleChange}
                                    rows="4"
                                    className="block w-full px-3 py-2 border border-gray-300 rounded-lg shadow-sm"
                                />
                            </div>

                            <div className="mb-4">
                                <label htmlFor="file" className="block text-sm font-medium text-gray-700">
                                    Upload Documents
                                </label>
                                <div className="flex items-center gap-4 mt-1">
                                    <input
                                        type="text"
                                        value={formData.file ? formData.file.name : ""}
                                        readOnly
                                        placeholder="No file selected"
                                        className="block w-full px-3 py-2 border border-gray-300 rounded-lg shadow-sm"
                                    />
                                    <label
                                        htmlFor="file"
                                        className="px-3 py-2 bg-[#92288C14] text-[#92288C] border border-[#92288C] rounded-md cursor-pointer"
                                    >
                                        Browse File
                                    </label>
                                    <input
                                        type="file"
                                        id="file"
                                        name="file"
                                        onChange={handleFileChange}
                                        className="hidden"
                                    />
                                </div>
                            </div>

                            <div className="mb-4">
                                <label htmlFor="authors" className="block text-sm font-medium text-gray-700">
                                    Authors
                                </label>
                                <input
                                    type="text"
                                    id="authors"
                                    name="authors"
                                    value={formData.authors}
                                    onChange={handleChange}
                                    className="block w-full px-3 py-2 border border-gray-300 rounded-lg shadow-sm"
                                />
                            </div>
                             <div className="grid grid-cols-2 gap-4 mb-6">
                                    <div >
                                        <label className="block mb-1 text-sm font-medium text-gray-600" htmlFor="journal_name">
                                        Journal Name
                                        </label>
                                        <input
                                            id="journal_name"
                                            name="journal_name"
                                            type="text"
                                            value={formData.journal_name}
                                            onChange={handleChange}
                                            className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none"
                                        />
                                    </div>
                                    <div>
                                        <label className="block mb-1 text-sm font-medium text-gray-600" htmlFor="publication_date">
                                        Publication Date
                                        </label>
                                        <input
                                            id="publication_date"
                                            name="publication_date"
                                            type="date"
                                            value={formatISODateForInput(formData.publication_date)}
                                            onChange={handleChange}
                                            className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none"
                                        />
                                    </div>
                                </div>

                            <div className="flex justify-end space-x-4">
                                <button
                                    type="button"
                                    className="px-4 py-2 text-gray-700 bg-gray-200 rounded-md"
                                    onClick={() => {handleToggle(1)}}
                                >
                                    Cancel
                                </button>
                                <button
                                    type="button"
                                    onClick={addNewPublication}
                                    className="px-4 py-2 bg-[#92288C] text-white rounded-md"
                                >
                                    Save
                                </button>


                            </div>
                        </form>
                    </div>
                )
                }
            </div>
            <dialog
                id="modal-edit"
                className="modal modal-bottom xl:modal-middle inset-0 z-50 rounded-lg w-[600px]"
            >
                <div className="p-6">
                    <h1 className="mb-6 text-2xl font-bold">Edit Publication</h1>
                    <form onSubmit={(e) => e.preventDefault()}>
                        <div className="flex items-start gap-6">
                        <div className="flex-1">
                                 <label htmlFor="title" className="block mb-2 text-gray-600">
                                     Title
                                 </label>
                                 <input
                                     type="text"
                                     id="title"
                                     name="title"
                                     value={formData.title}
                                     onChange={handleChange}
                                     className="block w-full px-3 py-2 border border-gray-300 rounded-lg shadow-sm"
                                 />
                             </div>
                         </div>
 
                         <div className="mb-4">
                             <label htmlFor="abstract" className="block text-sm font-medium text-gray-700">
                                 Abstract
                             </label>
                             <textarea
                                 id="abstract"
                                 name="abstract"
                                 value={formData.abstract}
                                 onChange={handleChange}
                                 rows="4"
                                 className="block w-full mt-1 border-gray-300 rounded-md shadow-sm"
                             />
                         </div>
 
                         <div className="mb-4">
                             <label htmlFor="file" className="block text-sm font-medium text-gray-700">
                                 Upload Documents
                             </label>
                             <div className="flex items-center gap-4 mt-1">
                                 <input
                                     type="text"
                                     value={formData.file ? formData.file.name || formData.file : ""}
                                     readOnly
                                     placeholder="No file selected"
                                     className="flex-grow px-3 py-2 text-gray-500 border-gray-300 rounded-md shadow-sm"
                                 />
                                 <label
                                     htmlFor="file"
                                     className="px-3 py-2 bg-[#92288C14] text-[#92288C] border border-[#92288C] rounded-md cursor-pointer"
                                 >
                                     Browse File
                                 </label>
                                 <input
                                     type="file"
                                     id="file"
                                     name="file"
                                     onChange={handleFileChange}
                                     className="hidden"
                                 />
                             </div>
                         </div>
 
                         <div className="mb-4">
                             <label htmlFor="authors" className="block text-sm font-medium text-gray-700">
                                 Authors
                             </label>
                             <input
                                 type="text"
                                 id="authors"
                                 name="authors"
                                 value={formData.authors}
                                 onChange={handleChange}
                                 className="block w-full mt-1 border-gray-300 rounded-md shadow-sm"
                             />
                         </div>
                         <div className="grid grid-cols-2 gap-4 mb-6">
                                    <div >
                                        <label className="block mb-1 text-sm font-medium text-gray-600" htmlFor="journal_name">
                                        Journal Name
                                        </label>
                                        <input
                                            id="journal_name"
                                            name="journal_name"
                                            type="text"
                                            value={formData.journal_name}
                                            onChange={handleChange}
                                            className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none"
                                        />
                                    </div>
                                    <div>
                                        <label className="block mb-1 text-sm font-medium text-gray-600" htmlFor="publication_date">
                                        Publication Date
                                        </label>
                                        <input
                                            id="publication_date"
                                            name="publication_date"
                                            type="date"
                                            value={formatISODateForInput(formData.publication_date)}
                                            onChange={handleChange}
                                            className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none"
                                        />
                                    </div>
                                </div>
 
                         <div className="flex justify-end space-x-4">
                             <button
                                 type="button"
                                 className="px-4 py-2 text-gray-700 bg-gray-200 rounded-md"
                                 onClick={() => {
                                     document.getElementById("modal-edit").close()
                                     setSelectedRowId(null)
                                     setFormData((prevState) => ({
                                         ...prevState,
 
                                         title: '',
                                         abstract: '',
                                         authors: '',
                                         journal_name:'',
                                         publication_date:''
                                     }))
                                 }}
                             >
                                 Cancel
                             </button>
                             <button
                                 type="button"
                                 onClick={editPublicationBtn}
                                 className="px-4 py-2 bg-[#92288C] text-white rounded-md"
                             >
                                 Save
                             </button>
 
 
                         </div>
                     </form>
                 </div>
             </dialog>
 
             <dialog
                 id="modal-delete"
                 className="inset-0 z-50 rounded-lg modal modal-bottom sm:modal-middle"
             >
 
                 <div className="relative z-10 w-full max-w-lg p-6 mx-auto bg-white rounded-lg shadow-lg">
                     <div className="text-center">
                         <h2 className="text-xl font-bold text-gray-900">
                             Delete
                         </h2>
                         <p className="font-bold text-gray-500">
                             Are you sure?
                         </p>
                     </div>
 
 
                     <div className="flex justify-center mt-4 space-x-4">
                         <button
                             onClick={() => {
                                 setSelectedRowId(null)
                                 document.getElementById("modal-delete").close()
                             }}
                             className="px-6 py-3 text-gray-600 transition bg-gray-200 rounded-lg hover:bg-gray-200 active:scale-95 hover:shadow-lg"
                         >
                             No
                         </button>
                         <button
                             onClick={async () => { deleteResearchPBtn(); }}
                             className="rounded-lg transition active:scale-95 hover:shadow-lg px-6 py-3 bg-[#92288C] text-white"
                         >
                             Yes
                         </button>
                     </div>
                 </div>
             </dialog>
 
         </Page>
 
     );
 };
 
 export default ResearchPublications;